import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import uniqid from "uniqid";
import { Breadcrumbs, Button, ContentBlock, FormGroup, Head, Icon, Pill, StatusDot } from "xsolla-uikit";
import { CSSedit } from '../uikit2';
// import PAloginSettings from "./login/PAloginSettings";
import { PAloginSBemail, PAloginSBwidget } from "../PAloginSBs";
// import PAloginSocials from "./PAloginSocials";
// import PAloginStats from "./login/PAloginStats";
// import PAtabs from "./PAtabs";
// import {PAusers} from "./PAusers";



export function Anchor({ id = uniqid() }) {
  return (
    <div>
      <a id={id} />
    </div>
  );
}





export default function PAloginWidget() {
  return (
    <div>

      <FormGroup indentation="lg">
              <FormGroup indentation="lg">
                <Anchor id="sbwidgets" />
                {/* <FormGroup indentation="xs">
                  <h3>Login Widget</h3>
                </FormGroup> */}
                <PAloginSBwidget editmode={false}>
                  <Link to="/sb0/login#login_w">
                    <CSSedit>
                      <FormGroup indentation="lg">
                        <FormGroup indentation="lg">
                          <div className="l_flex l_flex--center">
                            <Button size="lg" appearance="secondary">
                              <Icon name="settings" /> Set up visual
                            </Button>
                          </div>
                        </FormGroup>
                        <FormGroup indentation="lg">
                          <div className="l_flex l_flex--center">
                            <Button size="lg" appearance="flatten">
                              <Icon name="copy" /> Copy widget code
                            </Button>
                          </div>
                        </FormGroup>
                      </FormGroup>
                    </CSSedit>
                  </Link>
                </PAloginSBwidget>
              </FormGroup>

              <FormGroup indentation="lg">
                <Anchor id="sbemails" />
                {/* <FormGroup indentation="xs">
                  <h3>Login Emails</h3>
                </FormGroup> */}
                <PAloginSBemail editmode={false}>
                  <Link to="/sb0/login#login_mail">
                    <CSSedit>
                      <div className="l_flex l_flex--center">
                        <FormGroup indentation="lg">
                          <FormGroup indentation="lg">
                            <div className="l_flex l_flex--center">
                              <Button size="lg" appearance="secondary">
                                <Icon name="settings" /> Set up visual
                              </Button>
                            </div>
                          </FormGroup>
                          <FormGroup indentation="lg">
                            <div className="l_flex l_flex--center">
                              <Button size="lg" appearance="flatten">
                                <Icon name="copy" /> Copy widget code
                              </Button>
                            </div>
                          </FormGroup>
                        </FormGroup>
                      </div>
                    </CSSedit>
                  </Link>
                </PAloginSBemail>
              </FormGroup>
            </FormGroup>


    </div>
  )
}
